import React from 'react';
import { extractUsername } from './extractUsername';

const UserName = (props) => {
    const { user } = props,
        name = extractUsername(user);

    return <>{name}</>;
};

export default UserName;
